import React from 'react';
import GeneralErrorView from '../GeneralErrorView';

const NotAuthorizedErrorView = () => {
    return <GeneralErrorView status='403' title='Not Authorized' message='Sorry, you are not authorized to access this site.' />;
};

export default NotAuthorizedErrorView;
